import script from "./audios.vue?vue&type=script&setup=true&lang=ts"
export * from "./audios.vue?vue&type=script&setup=true&lang=ts"

import "./audios.vue?vue&type=style&index=0&id=e88e8a2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e88e8a2a"]])

export default __exports__